import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'user-notification';

export default {
  async getUserNotifications(queryParams) {
    const url = mountUrl(`/${BASE_PATH}/search`, queryParams);
    return api.get(url);
  },
  async getNewNotificationsQuantity() {
    const url = mountUrl(`/${BASE_PATH}/new-quantity`);
    return api.get(url);
  }
};
